import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const sections = [
  {
    title: "1. Who We Are",
    body: "Ocean Mind AI (\"we\", \"us\", \"our\") is an AI automation company registered in the United Kingdom. Our registered office is 4th Floor, 45 Silver Stream House, Fitzroy Street, Fitzrovia, London, W1T 6EB. You can reach us at team@oceanmindai.co.uk or on 020 3757 2456. We are the data controller for the personal data described in this policy.",
  },
  {
    title: "2. What We Collect",
    body: "When you use our website or contact form, we may collect: your name, email address, company name, and the contents of your message; technical data such as IP address, browser type and pages visited; and correspondence records when you contact us by email or phone.",
  },
  {
    title: "3. How We Use Your Data",
    body: "We use your data to respond to enquiries and provide quotes, to deliver and improve our services, to manage client relationships, and to meet legal and accounting obligations. We do not sell your personal data to third parties.",
  },
  {
    title: "4. Lawful Basis (UK GDPR)",
    body: "We process personal data under the following lawful bases: legitimate interests (responding to enquiries and running our business), contract (where we provide services to you), and legal obligation (tax and accounting records).",
  },
  {
    title: "5. Sharing & Storage",
    body: "Your data is stored securely and is only accessible to authorised team members. We may use trusted service providers (such as hosting and email providers) who process data on our behalf under strict confidentiality agreements. Data is retained only as long as necessary for the purposes described above.",
  },
  {
    title: "6. Your Rights",
    body: "Under UK GDPR you have the right to access, correct, or delete your personal data, to restrict or object to processing, and to data portability. To exercise any of these rights, contact team@oceanmindai.co.uk. You also have the right to lodge a complaint with the Information Commissioner's Office (ICO).",
  },
  {
    title: "7. Cookies",
    body: "Our website uses only essential cookies required for the site to function. We do not use advertising or tracking cookies without your consent.",
  },
  {
    title: "8. Changes to This Policy",
    body: "We may update this policy from time to time. The latest version will always be published on this page. Last updated: August 2026.",
  },
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#020813] text-[#E8F1F5]" data-testid="privacy-page">
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[10%] w-[500px] h-[500px] rounded-full bg-[#00F2FE]/[0.05] blur-[120px]" />
        <div className="absolute bottom-[5%] right-[5%] w-[600px] h-[600px] rounded-full bg-[#10E59A]/[0.04] blur-[140px]" />
      </div>
      <div className="relative max-w-3xl mx-auto px-6 py-20 lg:py-28">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-sm text-[#00F2FE] hover:text-[#10E59A] transition-colors duration-300 mb-12"
        >
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-[#10E59A] mb-5">Legal</p>
        <h1 className="font-['Outfit'] font-light text-4xl sm:text-5xl tracking-tight mb-4">
          Privacy <span className="gradient-text font-medium">Policy</span>
        </h1>
        <p className="text-sm text-[#8AA1B1] mb-14">Ocean Mind AI · www.oceanmindai.co.uk</p>
        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="font-['Outfit'] font-medium text-xl text-[#E8F1F5] mb-3">{s.title}</h2>
              <p className="text-sm leading-relaxed text-[#8AA1B1]">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
